import React from 'react';
import './App.css';
import RandomQuotes from './Components/RandomQuotes';

function App() {
  return (
    <RandomQuotes />
  );
}

export default App;
